import { statusBadgeClasses } from '~/components/ui/statusBadgeClasses';

type TitleWithArchivedBadgeProps = Readonly<{
  title: string;
  isArchived: boolean;
  archivedLabel: string;
  badgeTestId: string;
}>;

export function TitleWithArchivedBadge({
  title,
  isArchived,
  archivedLabel,
  badgeTestId,
}: TitleWithArchivedBadgeProps) {
  return (
    <div className="flex items-center gap-3">
      <h1 className="text-xl font-semibold text-neut-prim">{title}</h1>
      {isArchived && (
        <span
          className={statusBadgeClasses('neutral')}
          data-testid={badgeTestId}
        >
          {archivedLabel}
        </span>
      )}
    </div>
  );
}
